<template>
  <div>
    <div class="text-center mt-5 title-font">
      <span class="pricing-card-price" v-if="pricing">
        {{
          formatStripeAmount(
            pricing.subscription_price * 100,
            pricing.subscription_currency
          )
        }}
      </span>
      <span v-if="pricing.renewal_frequency === 'monthly'">/month </span>
      <span v-if="pricing.renewal_frequency === 'yearly'">/year </span>
    </div>
    <div class="ma-5">
      <v-btn
        v-if="!returnButton"
        class="btn-primary rounded-10"
        block
        large
        text
        @click="$emit('selection')"
      >
        Get started
      </v-btn>
      <v-btn
        v-if="returnButton"
        class="btn-primary rounded-10"
        block
        large
        text
        :to="{
          name: 'pricingPage'
        }"
      >
        Modify
      </v-btn>
    </div>
  </div>
</template>

<script>
import { formatStripeAmount } from "@/utils"

export default {
  props: ["pricing", "returnButton"],

  methods: {
    formatStripeAmount
  }
}
</script>
